var Container = require('./container');

module.exports = Container.extend({
    icon: 'icon-inbox',
    desc: 'Bin'
});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/viewer/models/container/bin.js
 ** module id = 396
 ** module chunks = 0
 **/